"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FaceDisapointed = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 Z M12,14 C13.4294636,14 14.692831,14.3609621 15.7773501,15.0839749 C16.0071144,15.2371511 16.0692014,15.5475858 15.9160251,15.7773501 C15.7628489,16.0071144 15.4524142,16.0692014 15.2226499,15.9160251 C14.307169,15.3057046 13.2372031,15 12,15 C10.7627969,15 9.69283097,15.3057046 8.7773501,15.9160251 C8.54758575,16.0692014 8.23715108,16.0071144 8.08397485,15.7773501 C7.93079862,15.5475858 7.99288556,15.2371511 8.2226499,15.0839749 C9.30716903,14.3609621 10.5705364,14 12,14 Z M14.639617,9.01979801 L14.7236068,9.0527864 L16.7236068,10.0527864 C16.970596,10.176281 17.0707082,10.4766175 16.9472136,10.7236068 C16.8374406,10.9431528 16.5879407,11.0466478 16.360383,10.980202 L16.2763932,10.9472136 L14.2763932,9.9472136 C14.029404,9.82371897 13.9292918,9.52338245 14.0527864,9.2763932 C14.1625594,9.0568472 14.4120593,8.95335223 14.639617,9.01979801 Z M9.36038302,9.01979801 C9.58794067,8.95335223 9.8374406,9.0568472 9.9472136,9.2763932 C10.0569866,9.4959392 9.99008262,9.75763613 9.8003914,9.89981478 L9.7236068,9.9472136 L7.7236068,10.9472136 L7.63961698,10.980202 C7.41205933,11.0466478 7.1625594,10.9431528 7.0527864,10.7236068 C6.94301341,10.5040608 7.00991738,10.2423639 7.1996086,10.1001852 L7.2763932,10.0527864 L9.2763932,9.0527864 L9.36038302,9.01979801 Z" })));
};
FaceDisapointed.displayName = 'FaceDisapointed';
exports.default = FaceDisapointed;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FaceDisapointed.js.map